import FormattedMessage from 'I18n/components/FormattedMessage';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import FeatureTableColTag from '../../../components/feature-table/FeatureTableColTag';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import FeatureTableFreePriceDisplay from '../../components/prices/FeatureTableFreePriceDisplay';
import { FreeToolsPurchaseMotion } from '../../containers/FreeToolsPurchaseMotion';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionContainer } from '../../containers/PurchaseMotionContainer';
import { useBadges } from '../../hooks/badges/useBadges';
import { useFormattedFeatureTableBodyData } from '../../hooks/features/useFormattedFeatureTableBodyData';
import { createFeatureTableHeaderTrackingData } from '../../utils/trackingData';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeToolsFeatureTable = ({
  isInApp = false
}) => {
  var _badges$hubspotFree, _badges$crmSuiteSta;
  const productApiNames = ['hubspot-free', 'crm-suite-starter-bundle'];
  const skuCategoryName = 'CRM_SUITE';
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames,
    skuCategoryName
  });
  const {
    badges
  } = useBadges({
    productApiNames
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: "100%"
    });
  }
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      'hubspot-free': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "hubspot-free",
            badgeName: badges === null || badges === void 0 || (_badges$hubspotFree = badges['hubspot-free']) === null || _badges$hubspotFree === void 0 ? void 0 : _badges$hubspotFree.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.freeCard.title"
          }),
          Price: /*#__PURE__*/_jsx(FeatureTableFreePriceDisplay, {}),
          PurchaseMotion: /*#__PURE__*/_jsx(FreeToolsPurchaseMotion, {
            trackingSource: "free-card",
            sourceId: "free-tools-feature-table",
            isInApp: isInApp
          })
        })
      },
      'crm-suite-starter-bundle': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "crm-suite-starter-bundle",
            badgeName: badges === null || badges === void 0 || (_badges$crmSuiteSta = badges['crm-suite-starter-bundle']) === null || _badges$crmSuiteSta === void 0 ? void 0 : _badges$crmSuiteSta.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "crm-suite-starter-bundle"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionContainer, {
            productApiName: "crm-suite-starter-bundle",
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData('crm-suite-starter-bundle', 'crm')
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data
  });
};